/* {
    "page_inbox": { "label": "Live chat", "selected": false },
    "customers": { "label": "Customers", "selected": false },
    "business_details": { "label": "Settings", "selected": false },
    "broadcast": { "label": "Broadcast", "selected": false },
    "integrations": {
        "label": "Channels",
        "whatsapp": { "label": "WhatsApp", "selected": false }
    },
    // "bot_builder": { "label": "Bot builder", "selected": false }
} */

const rolesDictionary = {
    "livechat": { "label": "Live chat", "selected": false },
    "botBuilder": { "label": "Bot builder", "selected": false },
    "broadcast": { "label": "Broadcast", "selected": false },
    "customers": {
        "label": "Customers",
        "manageCustomers": { "label": "Customers", "selected": false },
        "segments": { "label": "Segments", "selected": false },
    },
    "channels": {
        "label": "Channels",
        "whatsapp": {"label": "WhatsApp", "selected": false},
        "googlercs": {"label": "Google RCS", "selected": false},
        "vonagesms": {"label": "SMS", "selected": false}
    },
    "analytics": {
        "label": "Analytics",
        "broadcast": {"label": "Broadcast", "selected": false},
        /* "engagement": {"label": "Engagement", "selected": false}, */
        "customers": {"label": "Customers", "selected": false}
    },
    "settings": {
        "label": "Settings",
        "manageTeamMembers": {"label": "Manage team members", "selected": false},
        "liveChatSettings": {"label": "Live chat settings", "selected": false},
        "dataPrivacy": { "label": "Data privacy", "selected": false}
    }
}

export default rolesDictionary;